import type { GetServerSideProps } from 'next/types';

import { generateGrowthBookSSRProps, GrowthBookPageWrapper, GrowthBookPageWrapperProps } from '../../utils/growth-book';
import getOffersContent from '../utils/get-offers-content';
import getShouldSkipClientSideRequest from '../../src/client/utils/get-should-skip-client-side-request';
import RefinePriceComponent from '../../src/client/pages/refine-price';
import useGetOffersContent from '../utils/use-get-offers-content';
import type { Offer, Placeholder } from '../../src/client/components/offers/types';

type RefinePriceProps = {
  activeOffers: Offer[];
  placeholders: Placeholder[];
};

const RefinePricePage = ({
  activeOffers: serverSideOffers,
  placeholders: serverSidePlaceholders,
}: RefinePriceProps) => {
  const shouldSkip = getShouldSkipClientSideRequest();
  const { activeOffers, placeholders, loading: isOfferContentLoading } = useGetOffersContent({ shouldSkip });

  const content =
    shouldSkip || isOfferContentLoading
      ? {
          activeOffers: serverSideOffers,
          placeholders: serverSidePlaceholders,
        }
      : {
          activeOffers,
          placeholders,
        };

  return <RefinePriceComponent content={content} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const [growthBookData, { activeOffers, placeholders }] = await Promise.all([
    generateGrowthBookSSRProps(context),
    getOffersContent(),
  ]);

  return {
    props: {
      activeOffers,
      growthBookData,
      placeholders,
    },
  };
};

export default function WrappedPage(props: RefinePriceProps & GrowthBookPageWrapperProps) {
  return GrowthBookPageWrapper(props, RefinePricePage);
}
